import {CommonStatus} from "@/enums/status";
import {EmployeeType} from "@/enums/type";

export class EmployeeParams {
    page? = 1;
    limit? = 2;
    search?: string;
    type?: EmployeeType;
    status?: CommonStatus;
    postOfficeRowGuid?: string;

    constructor(page = 1, limit = 10, search?: string, type?: EmployeeType, status = CommonStatus.Active, postOfficeRowGuid?: string) {
        this.page = page;
        this.limit = limit;
        this.search = search;
        this.type = type;
        this.status = status;
        this.postOfficeRowGuid = postOfficeRowGuid;
    }
}
